import React, { ButtonHTMLAttributes } from "react";
import { Container } from "./styles";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({ onClick, children, ...rest }) => {
  return (
    <Container onClick={onClick} {...rest}>
      {children}
    </Container>
  );
};

export default Button;
